<template>
    <span class="ActionButton">
        <b-button :variant="ButtonVariant" :size="ButtonSize" @click="ButtonClick">{{ ButtonString }}</b-button>
        <b-modal ref="component-modal" title="CONFIRM ACTION"  hide-footer>
            <b-container>
                <b-form @submit="Save">
                    <b-row>
                        {{ ConfirmationString }}
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" @click="Save()">
                                CONFIRM
                            </b-button>
                        </div>

                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';
    export default {
        props: [
            "RequiresConfirmation",
            "ConfirmationString",
            "Endpoint",
            "Payload",
            "PerformGlobalUpdate",
            "ButtonVariant",
            "ButtonString",
            "ButtonSize",
            "ChartId",
            "Method"
        ],
        data: function () {
            return {
                
            };
        },
        methods: {
            ShowModal() {
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            ButtonClick() {
                if (this.RequiresConfirmation) {
                    this.ShowModal()
                } else {
                    this.Save();
                }
            },
            Save() {
                if (this.Method == "DELETE") {
                    this.$MasterAPI.ExecuteRequest("DELETE", this.Endpoint + "/" + this.Payload.Id, {}, this.SaveSuccess, () => { }, true);
                } else {
                    this.$MasterAPI.ExecuteRequest("POST", this.Endpoint, this.Payload, this.SaveSuccess, () => { }, true);
                }
                
            },
            SaveSuccess(response) {
                this.$refs['component-modal'].hide();
                //emit success response
                this.$emit("success");
                //Perform Global Updates
                if (this.PerformGlobalUpdate) {
                    this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                }
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            }
        },
        components: {

        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>